module.exports = __webpack_public_path__ + "img/488.3573203b.jpg";